import type { WhatsNewBody } from '../types';

export default {
  title: 'Logistics is told when a Materials line moves to Pickup',
  summary:
    'Setting a Materials line to the Pickup stage now sends Logistics a short message that a pickup is coming, so a line left waiting there does not go unnoticed.',
  details: [
    'The message names the item, the job and the vendor. It is not a Shipping request, so it carries no dimensions, weight, truck or onsite contact, and it is not on the Shipping list.',
    'Use Request pickup on the line to give Logistics those details. That raises a request, and Logistics is told again.',
    'Set Pickup when the material is ready to be collected. A line added already in Pickup sends the message too, and so does moving a line away from Pickup and back. A line that was already in Pickup before this change has not sent one, so use Request pickup on it.',
  ],
  tryIt: { to: '/projects', label: 'Open Projects' },
  // A module topic, which every reader can open: the entry has no audience, because Logistics reads this as much as a project manager does.
  guide: { topic: 'mod-shipping-pickup-notice' },
} satisfies WhatsNewBody;
